import 'react-app-polyfill/ie9'
import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import './firebaseInit'
import React from 'react'
import { render } from 'react-dom'
import Router from './components/Router'
import './css/index.css'
import 'normalize.css'
import * as serviceWorker from './serviceWorker'

if (process.env.REACT_APP_ENVIRONMENT === 'production') {
  console.log = function() {}
}

render(<Router />, document.getElementById('root'))

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
